module.exports = __webpack_public_path__ + "static/SaolText-BookItalic-0fd7015837578ef10ac65f80fb486e19.woff2";